import { FC, HTMLAttributes, ReactNode } from "react";
import { labels } from "../resources";
import { Abbreviations } from "../resources/abbreviations";
import { Constants } from "../utils/constants";
import { cn } from "../helper/classNames";

export type SearchFilterSchema = {
  value: string,
  key: string,
};

interface ICustomFilter extends Omit<HTMLAttributes<HTMLInputElement>, "onChange" | "title"> {
  title: string | ReactNode;
  handleChange?: (value: SearchFilterSchema) => void;
  searchKey?: string;
  isSearch?: boolean;
  className?: string;
  titleClassName?: string;
  isSorter?: boolean;
  hoverTitle?: string | labels | Abbreviations;
}

const CustomFilter: FC<ICustomFilter> = (props) => {
  const {
    title,
    handleChange = () => {},
    searchKey = "",
    isSearch = false,
    className = "",
    titleClassName,
    isSorter = false,
    hoverTitle = "",
    ...rest
  } = props;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === Constants.ENTER) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {title
        ? <p className={cn(titleClassName)} title={hoverTitle}>{title}</p>
        : <></>}
      {isSearch
        ? <input
          type="text"
          onChange={(e) => handleChange({ value: e.target.value.toString(), key: searchKey })}
          onKeyDown={handleKeyDown}
          className={cn("mt-1 w-full p-[2px] min-w-4 focus:!outline-none shadow-sm focus:!shadow-lg font-normal", isSorter ? "ml-2" : "", className)}
          {...rest} />
        : <></>}
    </div >
  );
};

export default CustomFilter;
